import { useLanguage } from '../context/LanguageContext';
import { Quote, MapPin, Briefcase } from 'lucide-react';

export const AboutSection = () => {
  const { t } = useLanguage();

  const expertiseItems = t('about.expertiseItems');
  const marketItems = t('about.marketItems');

  return (
    <section id="about" className="section-padding bg-white" data-testid="about-section">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 
            className="font-serif text-4xl md:text-5xl font-bold text-[#004d40] mb-4"
            data-testid="about-title"
          >
            {t('about.title')}
          </h2>
        </div>

        {/* Founder Section - Asymmetric Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {/* Video Column */}
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-[#004d40]">
              <video
                controls
                playsInline
                preload="metadata"
                className="w-full h-auto aspect-video object-cover"
                data-testid="about-video"
              >
                <source 
                  src="https://customer-assets.emergentagent.com/job_c6dd2c5d-713b-4be1-a54c-9cd952554724/artifacts/f21udztj_Episode%202%20Bicenter%20Consulting.mp4" 
                  type="video/mp4" 
                />
                Votre navigateur ne supporte pas la lecture vidéo.
              </video>
            </div>
          </div>

          {/* Content Column */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            {/* Founder Word Badge with Photo */}
            <div className="flex items-center gap-4 mb-6">
              {/* Circular Photo */}
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-full overflow-hidden border-2 border-[#4caf50] shadow-lg flex-shrink-0">
                <img
                  src="https://customer-assets.emergentagent.com/job_bicenter-paris/artifacts/xitktens_photo%20Entreprenariat%20sport%20business%20actualit%C3%A9%20internationale.jpg"
                  alt="Laurianne NGOUNOU"
                  className="w-full h-full object-cover object-[center_12%] scale-[1.4]"
                  data-testid="founder-photo-circle"
                />
              </div>
              <div>
                <span className="text-[#907b89] font-medium text-sm uppercase tracking-wide block">
                  {t('about.founderWord')}
                </span>
                <h3 className="font-serif text-xl font-bold text-[#004d40]">
                  {t('about.founderName')}
                </h3>
                <p className="text-[#4caf50] font-medium text-sm">
                  {t('about.founderTitle')}
                </p>
                <p className="text-[#4caf50] font-medium text-sm">
                  Diplômée d'un Master 2 en Management et Business Développement
                </p>
                <p className="text-[#4caf50] font-medium text-sm">
                  Experte en Closing et Entreprenariat
                </p>
              </div>
            </div>

            {/* Quote */}
            <div className="relative mb-8">
              <Quote className="absolute -top-4 -left-4 w-12 h-12 text-[#4caf50]/20" />
              <blockquote className="font-serif text-2xl md:text-3xl text-[#004d40] font-medium leading-relaxed pl-8 border-l-4 border-[#4caf50]">
                {t('about.founderQuote')}
              </blockquote>
            </div>

            {/* Bio */}
            <p className="text-slate-600 text-lg leading-relaxed mb-8">
              {t('about.bio')}
            </p>

            {/* Expertise & Markets */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Expertise */}
              <div className="bg-[#f8fafc] rounded-xl p-6">
                <div className="flex items-center gap-2 mb-4">
                  <Briefcase className="w-5 h-5 text-[#004d40]" />
                  <h4 className="font-bold text-[#004d40]">{t('about.expertise')}</h4>
                </div>
                <ul className="space-y-2">
                  {Array.isArray(expertiseItems) && expertiseItems.map((item, i) => (
                    <li key={i} className="text-slate-600 text-sm flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-[#4caf50] rounded-full" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Markets */}
              <div className="bg-[#f8fafc] rounded-xl p-6">
                <div className="flex items-center gap-2 mb-4">
                  <MapPin className="w-5 h-5 text-[#004d40]" />
                  <h4 className="font-bold text-[#004d40]">{t('about.markets')}</h4>
                </div>
                <ul className="space-y-2">
                  {Array.isArray(marketItems) && marketItems.map((item, i) => (
                    <li key={i} className="text-slate-600 text-sm flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-[#4caf50] rounded-full" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
